import React from 'react';

import { websites } from "../portfolio";
import {
    Container,
    Row,
} from "reactstrap";
import WebsiteCard from "../components/WebsiteCard";
import { Fade } from 'react-reveal';

const Websites = () => {
    return ( 
        <section className="section section-lg">
			<h1 className="h1 header-aligner">References</h1>
            <Container>
              <Fade bottom duration={1000} distance="40px">
              <div className="d-flex p-4">
                    <div>
                        <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-info">
                        <i className="ni ni-laptop text-info" />
                        </div>
                    </div>
                    <div className="pl-4">
                        <h4 className="display-3 text-info">Websites</h4>
                    </div>
                </div>
                <Row className="row-grid align-items-center">
                    {
                        websites.map((data, i) => {
                            return <WebsiteCard key={i} data={data} />
                        })
                    }
                </Row>
              </Fade>
            </Container>
          </section>
     );
}
 
export default Websites;